import request from '@/utils/request'

export function getAccountTermsList() {
  return request({
    url: '/mgr/accountTerms/getAccountTermsList',
    method: 'get'
  })
}